<template>
	<div>
		<ts-loading-banner :loading="loading">
			<div class="ts-space-y-4">
				<div class="row">
					<div class="col-md-12">
						<label class="required">{{ $t('visitation.date') }}</label>
						<a-date-picker
							v-model="model.plan_date"
							format="DD-MM-YYYY"
							valueFormat="DD-MM-YYYY"
							class="ts-w-full"
						></a-date-picker>
						<div class="validate" v-if="errors.has('plan_date')">
							{{ errors.first('plan_date') }}
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<label class="required">{{ $t('visitation.saleName') }}</label>
						<a-select
							v-model.number="model.sale_id"
							:options="saleList" 
							class="ts-w-full"
							@change="fetchCustomer"
							showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
						></a-select>
						<div class="validate" v-if="errors.has('sale_id')">
							{{ errors.first('sale_id') }}
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12">
						<label class="required">{{ $t('visitation.customer') }}</label>
						<a-select
							v-model="model.customer_list"
							mode="multiple" 
							class="ts-w-full"
							:options="customerList"
							showSearch
              :filterOption="(input, option) => option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0"
						></a-select>
						<div class="validate" v-if="errors.has('customer_list')">
							{{ errors.first('customer_list') }}
						</div>
					</div>
				</div>
				<div class="row">
					<div class="col-md-12 ts-mt-3 text-right">
						<ts-button class="mr-2" @click.prevent="() => $emit('cancel')">
							{{ $t('cancel') }}
						</ts-button>
						<ts-button
							v-if="!isUpdate"
							class="mr-2"
							color="primary"
							outline
							@click.prevent="onSaveAddNew"
							:waiting="waiting_new"
							>{{ $t('save_add_new') }}</ts-button
						>
						<ts-button
							v-if="!isUpdate"
							color="primary"
							@click.prevent="onSave"
							:waiting="waiting"
							>{{ $t('save') }}</ts-button
						>
						<ts-button
							v-if="isUpdate"
							color="primary"
							@click.prevent="onUpdate"
							:waiting="waiting"
							>{{ $t('update') }}</ts-button
						>
					</div>
				</div>
			</div>
		</ts-loading-banner>
	</div>
</template>

<script>
import moment from 'moment'
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
	name: 'visitCustomer',
	data() {
		return {
			loading: false,
			waiting_new: false,
			waiting: false,
			customerList: [],
			errors: new Errors(),
			model: {
				plan_id: null,
				sale_id: null,
				plan_date: moment().format('DD-MM-YYYY'),
				customer_list: []
			}
		}
	},
	created(){
		this.loading = true
		this.fetchResources().finally(() => {
			this.loading = false
		})
		this.setEditData()
	},
	computed: {
    ...mapState('customer/visitation', ['edit_data']),
    // customerList() {
    //   return this.$store.state.customer.visitation.customers.map((el) => ({
    //     value: el.customer_id,
    //     label: el.customer_name,
    //   }))
    // },
    saleList() {
      return this.$store.state.customer.visitation.salers.map((el) => ({
        value: el.user_id,
        label: el.name,
      }))
    },
    isUpdate() {
      return !_.isEmpty(this.edit_data)
    },
  },
	methods: {
		...mapActions('customer/visitation', ['fetchResources', 'getCustomer']),
		onSave() {
      this.waiting = true
			this.errors = new Errors()
      this.$store
        .dispatch('customer/visitation/store', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
		onSaveAddNew() {
      this.waiting_new = true
			this.errors = new Errors()
      this.$store
        .dispatch('customer/visitation/store', this.model)
        .then((response) => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    onUpdate() {
      this.waiting = true
			this.errors = new Errors()
      this.$store
        .dispatch('customer/visitation/update', {
          id: this.model.plan_id,
          data: this.model,
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('cancel')
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
		clearInput(){
			this.model.plan_id = null
			this.model.sale_id = null
			this.model.plan_date = moment().format('DD-MM-YYYY')
			this.model.customer_list = []
		},
		async setEditData() {
      if (!_.isEmpty(this.edit_data)) {
				await this.fetchCustomer(this.edit_data.sale_id)
       	this.model.plan_id = this.edit_data.plan_id
       	this.model.sale_id = this.edit_data.sale_id
				this.model.plan_date = this.edit_data.plan_date
				this.model.customer_list = this.edit_data.customer_list.map(el => el.customer_id)
      }
    },
		fetchCustomer(saleId){
			this.customer_id = []
			this.loading = true
			this.getCustomer({ 
				filter: {
					sale_id: saleId
				}
			})
			.then(response => {
				this.customerList = response.data.map((el) => ({
					value: el.customer_id,
					label: el.customer_name,
				}))
			})
			.catch((error) => {
				this.$toasted.error(error.message)
			})
			.finally(() => {
				this.loading = false
			})
		}
	},
}
</script>